import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'urlData'
})
export class UrlDataPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value) return null;
    return null;
  }

}
